<template>
  <input v-bind="$props" type="search" ref="input" :value="value" @input="onChange" />
</template>

<script>
export default {
  props: {
    delay: {
      type: Number,
      default: 500,
      required: false,
    },
    value: {
      type: String,
      default: '',
      required: true,
    },
    refocus: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  data() {
    return {
      timerId: null,
    }
  },
  watch: {
    refocus: function () {
      this.$refs.input.focus()
    },
  },
  destroyed() {
    if (this.timerId) {
      clearTimeout(this.timerId)
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.$refs.input.focus()
    })
  },
  methods: {
    onChange(evt) {
      const { value } = evt.target
      // we don't debounce when clearing the input, so
      // the suggestions are shown again right away when a user deletes a search
      const delay = value === '' ? 0 : this.delay
      if (this.timerId) {
        clearTimeout(this.timerId)
      }
      this.timerId = setTimeout(() => {
        this.$emit('stopped', value)
      }, delay)
    },
  },
}
</script>
